var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 132,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.724 55.067v73.124a3.642 3.642 0 01-3.635 3.635H6.405a3.643 3.643 0 01-3.634-3.635V55.067a3.638 3.638 0 013.634-3.635H85.09a3.638 3.638 0 013.635 3.635z",
    fill: "#AAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.48 131.771H39.99a3.853 3.853 0 01-2.634-.983 3.358 3.358 0 01-1.122-2.432V55.187a3.36 3.36 0 011.122-2.432 3.857 3.857 0 012.634-.983H51.48c.982-.011 1.93.342 2.634.983a3.36 3.36 0 011.121 2.432v73.169a3.359 3.359 0 01-1.121 2.432 3.858 3.858 0 01-2.634.983zM59.106 10.844c2.476 7.14-4.81 16.15-4.81 16.15s-11.3-2.566-13.775-9.706c-2.476-7.14 4.81-16.151 4.81-16.151s11.3 2.566 13.775 9.707z",
    fill: "#404040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.581 32.394c-7.133 2.498-16.166-4.76-16.166-4.76s2.531-11.307 9.664-13.805c7.133-2.498 16.166 4.76 16.166 4.76s-2.531 11.307-9.664 13.805z",
    fill: "#404040"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.32 67.554a3.63 3.63 0 01-3.23-.212L3.334 19.1a3.633 3.633 0 01-1.31-4.97L7.41 4.892a3.634 3.634 0 014.97-1.31l82.754 48.242a3.635 3.635 0 011.31 4.971l-5.384 9.236a3.615 3.615 0 01-1.74 1.522z",
    fill: "#AAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.133 21.696l-9.689 16.626 15.888 9.258 9.688-16.626-15.887-9.258z",
    fill: "#404040"
  })));
}
export default __webpack_public_path__ + "static/media/gift-open.8748f1bd.svg";
export { SvgGiftOpen as ReactComponent };